import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountUser = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectUserData);
};
